import { TitleResponse } from 'src/modules/member/models/titleResponse';
import { PagedResult } from '../models/pagedResult';
import AxiosInstance from './axios/interceptor';

const controller = 'title';

/* eslint-disable camelcase */
export type TitleRequest = {
  title_id?: number;
  title: string;
  position: number;
  type: number;
  required: boolean;
  userFlags?: number | null;
};

// Alla uppdrag, oavsett nivå. Servern sätter canUse på de uppdrag användaren får redigera och
// tilldela, övriga visas men går bara att läsa.
export const getAllTitles = (type: number | null) => {
  const params: string[] = [];

  if (type) params.push(`type=${type}`);

  const endpoint = `${controller}${params.length > 0 ? `?${params.join('&')}` : ''}`;

  return AxiosInstance.get<PagedResult<TitleResponse>>(endpoint);
};

export const createTitle = (data: TitleRequest) => {
  return AxiosInstance.post<number>(controller, data);
};

export const updateTitle = (data: TitleRequest) => {
  return AxiosInstance.put<number>(controller, data);
};

export const deleteTitle = (titleId: number) => {
  return AxiosInstance.delete<number>(`${controller}/${titleId}`);
};
